var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7C19 5.9 18.1 5 17 5H15C14.4477 5 14 5.44772 14 6C14 6.55228 14.4477 7 15 7H17V9.65L13.52 14H10V10C10 9.44772 9.55228 9 9 9H6C3.79 9 2 10.79 2 13V15C2 15.5523 2.44772 16 3 16H4C4 17.66 5.34 19 7 19C8.66 19 10 17.66 10 16H14.48L19 10.35V7ZM4 14V13C4 11.9 4.9 11 6 11H8V14H4ZM7 17C6.45 17 6 16.55 6 16H8C8 16.55 7.55 17 7 17Z",
    fill: "#1C1F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6H6C5.44772 6 5 6.44772 5 7C5 7.55228 5.44772 8 6 8H9C9.55228 8 10 7.55228 10 7C10 6.44772 9.55228 6 9 6Z",
    fill: "#1C1F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13C17.34 13 16 14.34 16 16C16 17.66 17.34 19 19 19C20.66 19 22 17.66 22 16C22 14.34 20.66 13 19 13ZM19 17C18.45 17 18 16.55 18 16C18 15.45 18.45 15 19 15C19.55 15 20 15.45 20 16C20 16.55 19.55 17 19 17Z",
    fill: "#1C1F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoto);
export default __webpack_public_path__ + "static/media/Ic_moto.385f5fb80f86529f89fe449498aea7e2.svg";
export { ForwardRef as ReactComponent };